export default "__VITE_ASSET__DZHNoTa2__"